import React from "react"
import PropTypes from "prop-types"
import Button from "../shared/button/text-button"
import "./marketing.scss"

const MarketingReinvent = ({ handleButtonClick }) => (
  <div className="marketing-page">
    <div className="info">
      <div className="image">
        <img src="images/marketing/5g.png" alt="4G" />
      </div>
      <div className="text">
        <p>
          We now split your contract into two parts - one for your phone and one
          for your airtime plan. All our airtime plans are 5G Ready, come with
          unlimited minutes and texts plus we now have a range of plans offering
          unlimited data. This means you can use as much data as you want, all
          day, everyday.
        </p>
        <p>
          You can use any plan within the EU at no extra cost and because your
          airtime plan is completely separate, you can change it up or down
          every month.
        </p>
        <h3>What is 5G?</h3>
        <p>
          5G can carry more information at once and at faster speeds than 4G to
          provide a more reliable mobile experience overall
        </p>
        <p>
          With a 5G-ready smartphone you can connect to this new network and
          take advantage of its improved capacity; which means that even when
          you’re in a crowd, at a music festival, or on a busy train, you’ll be
          able to connect quickly to the network. You can download films in
          seconds rather than minutes, stream music on-the-go with no pauses or
          gaps, and never miss a beat with seamless, lag free video streaming
          and online gaming
        </p>
        <p>
          In the longer-term 5G will enable exciting future innovations, such as
          smart homes, fully-connected devices and holographic technologies.
        </p>
      </div>
    </div>
    <div className="marketing-button-container">
      <Button text="Continue" onClick={handleButtonClick} />
    </div>
  </div>
)

MarketingReinvent.propTypes = {
  handleButtonClick: PropTypes.func.isRequired
}

export default MarketingReinvent
